var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "specialties",
    class: {
      'adjust-container': _vm.isFullScreenView && !_vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-row', {
    class: {
      'px-0 pt-0 px-sm-10 pt-sm-10': !_vm.isFullScreenView,
      'specialties-head-options': _vm.isOnboarding
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.isGuestUser && !_vm.$vuetify.breakpoint.xsOnly || _vm.isGuestFilterUser ? _c('v-col', {
    staticClass: "col-8 pb-2 text-left"
  }, [_c('h6', {
    staticClass: "text text-l-large-bold grey--text text--darken-1"
  }, [_vm._v("Select specialties")])]) : _vm._e(), _vm.isGuestUser && !_vm.$vuetify.breakpoint.xsOnly || _vm.isGuestFilterUser ? _c('v-col', {
    staticClass: "col-4 d-flex align-center justify-end"
  }, [_c('ph-x', {
    staticClass: "clickable grey--text text--lighten-1 close-icon-position",
    attrs: {
      "weight": "thin",
      "size": "32"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1) : _vm._e(), _c('v-col', {
    class: {
      'pt-4 pt-sm-0': _vm.isFullScreenView
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text grey--text text--darken-1 mb-0",
    class: _vm.$vuetify.breakpoint.width < 375 ? 'text-l-small-regular' : 'text-l-large-regular'
  }, [_vm._v(" " + _vm._s('Select specialties and subspecialties that interest you. Start with your area of medical practice.') + " ")])]), _c('v-col', {
    staticClass: "col-12 pt-4"
  }, [_c('v-text-field', {
    staticClass: "specialties-search",
    attrs: {
      "solo": "",
      "height": "54px",
      "hide-details": "",
      "placeholder": "Search specialty"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('ph-magnifying-glass', {
          staticClass: "grey--text text--lighten-2 mr-2",
          attrs: {
            "weight": "thin",
            "size": "24"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)], 1), _c('div', {
    staticClass: "specialties-container"
  }, [_c('v-row', {
    staticClass: "justify-center mx-0 mx-sm-0",
    class: {
      'chips-container': !_vm.isFullScreenView
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.loadingSpecialties ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('ProgressBarComponent', {
    attrs: {
      "title": 'Specialties'
    }
  })], 1) : _vm._e(), _c('v-col', {
    staticClass: "px-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, _vm._l(_vm.specsPartialLeft, function (spec, i) {
    return _c('SpecialtyChipComponent', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: spec.show,
        expression: "spec.show"
      }],
      key: spec.id,
      staticClass: "mr-sm-2 mb-4",
      attrs: {
        "primary-index": i,
        "primary-title": spec.primary,
        "primary-id": spec.id,
        "subspecialties": spec.subspecialties,
        "force-selection": spec.forceSelection,
        "current-selecteds-count": _vm.currentSelectedSpecialtiesCount
      },
      on: {
        "select": _vm.selectSpecialty,
        "deselect": _vm.deselectSpecialty,
        "select-sub": _vm.selectSubSpecialty,
        "deselect-sub": _vm.deselectSubSpecialty
      }
    });
  }), 1), _c('v-col', {
    staticClass: "px-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, _vm._l(_vm.specsPartialRight, function (spec, i) {
    return _c('SpecialtyChipComponent', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: spec.show,
        expression: "spec.show"
      }],
      key: spec.id,
      staticClass: "ml-sm-2 mb-4",
      attrs: {
        "primary-index": i + _vm.specsPartialLeft.length,
        "primary-title": spec.primary,
        "primary-id": spec.id,
        "subspecialties": spec.subspecialties,
        "force-selection": spec.forceSelection,
        "current-selecteds-count": _vm.currentSelectedSpecialtiesCount
      },
      on: {
        "select": _vm.selectSpecialty,
        "deselect": _vm.deselectSpecialty,
        "select-sub": _vm.selectSubSpecialty,
        "deselect-sub": _vm.deselectSubSpecialty
      }
    });
  }), 1)], 1)], 1), !_vm.loadingSpecialties && !_vm.isFullScreenView ? _c('v-row', {
    staticClass: "sticky-actions-container px-6 pb-6 px-sm-10 pb-sm-10 justify-center d-flex",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-card', {
    staticClass: "actions-component-sticky",
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "justify-sm": "end",
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('div', {
    staticClass: "col col-sm-auto"
  }, [_c('v-btn', {
    staticClass: "heading heading-s-small text-capitalize px-6 white--text",
    attrs: {
      "disabled": _vm.currentSelectedSpecialtiesCount === 0 && !_vm.isGuestFilterUser,
      "height": "44px",
      "ripple": "",
      "depressed": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.submitSpecialties.apply(null, arguments);
      }
    }
  }, [_vm._v(" Continue ")])], 1)])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }